import React from "react";

export function FoodAndDrinkIcon({
  size = 16,
  color = "currentColor",
  style,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.66683 1.33398C7.03348 1.33401 7.3335 1.634 7.3335 2.00065V6.1276C7.33334 7.00747 6.61314 7.72721 5.73324 7.72721H5.3335V13.6673C5.3335 14.2206 4.88681 14.6673 4.3335 14.6673C3.78016 14.6673 3.3335 14.2207 3.3335 13.6673V7.72721H2.93376C2.05385 7.72721 1.33365 7.00747 1.3335 6.1276V2.00065C1.3335 1.63398 1.6335 1.33398 2.00016 1.33398C2.36681 1.33401 2.66683 1.634 2.66683 2.00065V4.1276H3.66683V2.00065C3.66683 1.63398 3.96683 1.33398 4.3335 1.33398C4.70014 1.33401 5.00016 1.634 5.00016 2.00065V4.1276H6.00016V2.00065C6.00016 1.63398 6.30016 1.33398 6.66683 1.33398Z"
        fill="currentColor"
      />
      <path
        d="M11.48 1.33398C13.04 1.33398 14.3399 2.50086 14.5132 4.04753L14.6532 5.2806C14.7465 6.1406 14.4734 7.00763 13.8934 7.6543C13.5102 8.08147 13.0189 8.3852 12.48 8.54297V13.6673C12.48 14.2207 12.0333 14.6673 11.48 14.6673C10.9267 14.6672 10.48 14.2206 10.48 13.6673V8.54102C9.94116 8.38173 9.4497 8.07704 9.06657 7.6543C8.48657 7.0143 8.21347 6.14727 8.3068 5.2806L8.44678 4.04753C8.62011 2.50091 9.92005 1.33406 11.48 1.33398Z"
        fill="currentColor"
      />
    </svg>
  );
}
